<!-- Breadcrumb padronizado -->
<app-breadcrumb containerStyle="wide"></app-breadcrumb>

<div class="container">
  <!-- Card Container das Permissões -->
  <div class="card">
    <div class="card-body">
      <!-- Título dentro do card -->
      <h3 class="mb-4">Permissões do Cliente</h3>

      <!-- Estado: Sem Permissões -->
      <div *ngIf="permissoes && permissoes.length === 0" class="no-permissoes">
        <!-- Mensagem de orientação -->
        <p class="text-muted text-center">
          Adicione uma nova permissão clicando no botão "Adicionar Permissão"
        </p>
      </div>

      <!-- Estado: Permissões Cadastradas -->
      <div
        *ngFor="let permission of permissoes| slice: (page-1) * pageSize : (page-1) * pageSize + pageSize; let first = first; let last = last"
        class="card permissao-card"
        [ngClass]="{'first-card': first, 'last-card': last, 'middle-card': !first && !last}"
      >
        <div class="card-body pt-0 pb-0">
          <!-- Título e Pill -->
          <div class="d-flex justify-content-between align-items-center mt-0 mb-3">
            <h5 class="card-title text-start">
              {{ permission.modulo }}
            </h5>
            <span
              class="badge-pill"
              [ngClass]="permission.ativo ? 'pill-success' : 'pill-danger'"
            >
              {{ permission.ativo ? "ATIVO" : "INATIVO" }}
            </span>
          </div>
          <div class="row">
            <!-- Informações da Permissão -->
            <div class="col-8 card-text mt-1">
              <p>
                <strong>Válido Até:</strong>
                <span>{{ getExpirationDate(permission.data_validade) }}</span>
              </p>
            </div>

            <!-- Botões de Ação -->
            <div class="col-4 actions d-flex justify-content-end align-items-center">
              <button
                class="btn btn-outline-danger"
                (click)="deletePermissao(permission.id)"
                title="Excluir"
              >
                <i class="fa fa-trash"></i>
              </button>
              <button
                class="btn btn-outline-primary"
                (click)="editPermission(permission, novapermissao)"
                title="Editar"
              >
                <i class="fa fa-edit"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Paginação dentro do card -->
      <div class="mt-4 d-flex justify-content-center" *ngIf="permissoes.length > pageSize">
        <ngb-pagination 
          [(page)]="page"
          [pageSize]="pageSize"  
          [maxSize]="12"
          [collectionSize]="permissoes.length">
        </ngb-pagination>
      </div>

      <!-- Botões de Ação dentro do card -->
      <div class="mt-4 d-flex justify-content-between">
        <button type="button" class="btn btn-outline-primary" (click)="goBack()">
          Voltar
        </button>
        <button class="btn btn-primary" [disabled]="temTodasAsPermissoes()" (click)="abrirModal(novapermissao)">
          Adicionar Permissão
        </button>
      </div>
    </div>
  </div>
</div>

  <ng-template #novapermissao let-modal>
    <div class="modal-header border-0 pb-0">
      <h4 class="modal-title">{{permission.id ? 'Editar Permissão' : 'Nova Permissão'}}</h4>
      <button type="button" class="btn-close" aria-label="Close" style="font-size: 24px" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    
    <!-- Linha divisória após título principal -->
    <hr class="modal-divider">
    <div class="modal-body">
      <h6 class="section-title">Informações Básicas</h6>
      
      <form #exForm="ngForm" class="editForm" novalidate>
         <!-- Validade Indeterminada + Data -->
          <div class="row">

      <div class="col-12 col-md-4 mb-3 d-flex align-items-center justify-content-center">
        <label>
          <input
            type="checkbox"
            [(ngModel)]="validadeIndeterminada"
            (change)="toggleValidadeIndeterminada()"
            name="validadeIndeterminada"
          />
          Validade Indeterminada
        </label>
        </div>
        <div class="col-12 col-md-3 mb-3">
          <label for="validade">Validade:</label>
          <input
            type="date"
            id="data_validade"
            class="form-control"
            [(ngModel)]="permission.data_validade"
            [disabled]="validadeIndeterminada"
            name="data_validade"
            #inputValidade="ngModel"
          />
        </div>

      <!-- Módulo -->
      <div class="col-12 col-md-5 mb-3">
        <label for="modulo">Módulo:</label>
        <ng-select
          [appendTo]="'body'"
          [items]="modulos"
          bindLabel="nome"
          bindValue="id"
          placeholder="Módulo"
          id="id_modulo"
          [(ngModel)]="permission.id_modulo"
          name="id_modulo"
          #inputModulo="ngModel"
        ></ng-select>
      </div>
    </div>

    <div class="row" *ngIf="permission.id">
      <div class="col-12">
        <div class="col-12 col-md-5 mb-3">
          <label for="modulo">Ativo:</label>
          <ng-select
            [appendTo]="'body'"
            [items]="status"
            bindLabel="nome"
            bindValue="id"
            placeholder="Ativo"
            id="ativo"
            [(ngModel)]="permission.ativo"
            name="ativo"
            #inputModulo="ngModel"
          ></ng-select>
        </div>
      </div>
      </div>
        <!-- Permissões -->
        <div class="mb-3 d-none">
          <label>
            <input
              type="checkbox"
              [(ngModel)]="selecionarTodas"
              (change)="selecionarTodasPermissoes($event)"
              name="selecionarTodas"
            />
            Todas
          </label>
          <div class="form-check" *ngFor="let permissao of permissoes; let i = index">
            <input
              type="checkbox"
              class="form-check-input"
              [(ngModel)]="permissao.selecionada"
              [name]="'permissao_' + i"
            />
            <label class="form-check-label">{{ permissao.nome }}</label>
          </div>
        </div>
      </form>
      
    </div>
    <div class="modal-footer border-0 pt-0">
      <!-- HR no rodapé ao invés de linha inteira -->
      <hr class="footer-divider">
      <div class="d-flex">
        <button type="button" class="btn btn-outline-primary" (click)="modal.dismiss('Cancel')">
          Voltar
        </button>
        <button type="button" class="btn btn-primary"
                (click)="savePermission()"
                [disabled]="!permission.id_modulo || !idCidade">
          {{permission.id ? 'Atualizar' : 'Cadastrar'}}
        </button>
      </div>
    </div>
  </ng-template>
  <ngx-spinner></ngx-spinner>
  